import { IconButton, LuIcon } from "@overmap-ai/blocks"
import { type ComponentPropsWithRef, memo } from "react"

import { useFallbackEditor, useHighlightState } from "../../hooks"
import { tipTapIconMapping } from "../mappings"
import type { OptionalEditorProps } from "../typings"

interface TextHighlightButtonProps
	extends Omit<ComponentPropsWithRef<typeof IconButton>, "children">, OptionalEditorProps {}

export const TextHighlightButton = memo<TextHighlightButtonProps>((props) => {
	const { ref, editor: editorFromProps, ...rest } = props

	const editor = useFallbackEditor(editorFromProps)
	const state = useHighlightState(editor)

	return (
		<IconButton ref={ref} {...rest}>
			<LuIcon icon={tipTapIconMapping.textHighlight} color={state.color} />
		</IconButton>
	)
})
TextHighlightButton.displayName = "TextHighlightButton"
